import React from "react";
import { Link } from "react-router-dom";
import { useTilt } from "../../lib/hooks";
import { ArrowUpRight } from "../../lib/icons";

const ProjectCard = ({ project }) => {
  const { ref, onPointerMove, onPointerLeave } = useTilt();

  const body = (
    <>
      <div className="pcard__media">
        <img
          src={project.image}
          alt=""
          width="640"
          height="400"
          loading="lazy"
          decoding="async"
        />
        <span className="pcard__year" data-badge={Boolean(project.badge)}>
          {project.badge || project.tags[0]}
        </span>
      </div>
      <div className="pcard__body">
        <h3 className="pcard__title">
          {project.title}
          {project.href && <ArrowUpRight size={16} />}
        </h3>
        <p className="pcard__blurb">{project.blurb}</p>
        <ul className="chip-row">
          {project.tags.map((tag) => (
            <li key={tag} className="chip">{tag}</li>
          ))}
        </ul>
      </div>
    </>
  );

  const className = "card card--spot card--tilt pcard";
  const isExternal = project.href?.startsWith("http");

  if (isExternal) {
    return (
      <a
        ref={ref}
        href={project.href}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        onPointerMove={onPointerMove}
        onPointerLeave={onPointerLeave}
      >
        {body}
      </a>
    );
  }

  if (project.href) {
    return (
      <Link
        ref={ref}
        to={project.href}
        className={className}
        onPointerMove={onPointerMove}
        onPointerLeave={onPointerLeave}
      >
        {body}
      </Link>
    );
  }

  return (
    <article
      ref={ref}
      className={className}
      onPointerMove={onPointerMove}
      onPointerLeave={onPointerLeave}
    >
      {body}
    </article>
  );
};

export default ProjectCard;
